// extracted by mini-css-extract-plugin
export default {"token":"b1y2uH","hover":"c1y2uH"};